import type { CatalogResource } from '../../types.js';
import { FEATURE_GROUP_KEYS } from '../feature-groups.js';
import { ROLE_KEYS } from '../roles.js';

const GROUP = FEATURE_GROUP_KEYS.RISK_MANAGEMENT;
const defaultGrants = {
  [ROLE_KEYS.COMPANY_ADMIN]: 'all',
  [ROLE_KEYS.COMPANY_CREATOR]: 'all',
  [ROLE_KEYS.COMPANY_READER]: ['read'],
} as const;

export const riskManagement = [
  {
    key: 'risk',
    name: 'Risk',
    description: 'Risk assessment and monitoring',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
] as const satisfies readonly CatalogResource[];
